/**
 * AI microservice client.
 * In development, requests go to /api/v1/* which is proxied to the AI service
 * by src/setupProxy.js — no CORS headers or JWT tokens are sent.
 * In production, set REACT_APP_AI_SERVICE_URL to the public AI service base URL.
 */
const BASE = process.env.REACT_APP_AI_SERVICE_URL
  ? process.env.REACT_APP_AI_SERVICE_URL.replace(/\/$/, "")
  : "";   // empty = relative path, handled by dev proxy

export async function transcribeAudio(file, opts = {}) {
  const fd = new FormData();
  fd.append("file", file);
  if (opts?.language) fd.append("language", opts.language);
  const r = await fetch(`${BASE}/api/v1/transcribe`, {
    method: "POST",
    body: fd,
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function structureReport(body) {
  const r = await fetch(`${BASE}/api/v1/structure-report`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function genImpression(body) {
  const r = await fetch(`${BASE}/api/v1/gen-impression`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function checkCritical(report_text) {
  const r = await fetch(`${BASE}/api/v1/check-critical`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ report_text }),
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}
